/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {CementStrengthSettings, FreelimeSettings, ProblemDetails} from './data-contracts'
import {ContentType, genApiClient, RequestParams} from './http-client'

export class PlantSettingsApi {
  /**
   * No description
   *
   * @tags PlantSettings
   * @name PlantsSettingsFreelimeUpdate
   * @request PUT:/predict/plants/{plantId}/settings/freelime
   * @secure
   */
  static plantsSettingsFreelimeUpdate = (
    plantId: string,
    data: FreelimeSettings,
    params: RequestParams = {}
  ) =>
    genApiClient.request<void, ProblemDetails | void>({
      path: `/predict/plants/${plantId}/settings/freelime`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params
    })
  /**
   * No description
   *
   * @tags PlantSettings
   * @name PlantsSettingsCementStrengthUpdate
   * @request PUT:/predict/plants/{plantId}/settings/cementStrength
   * @secure
   */
  static plantsSettingsCementStrengthUpdate = (
    plantId: string,
    data: CementStrengthSettings,
    params: RequestParams = {}
  ) =>
    genApiClient.request<void, ProblemDetails | void>({
      path: `/predict/plants/${plantId}/settings/cementStrength`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params
    })
}
